/*
---------------------------------
Module - smp-search-table-result
---------------------------------

data-config attribute contains an object with two properties:
{
        "columns": {
            "Description": "Description",
            "Year": "Year",
            "ApplicationNo": "Application Number",
            "LastModified": "Last Modified"
        },
        "detailsColumns": ["Description", "Year", "ApplicationNo", "LastModified"]
    }

data-results attribute contains an array of objects:
[{
    "ServiceID": "381b294ce8bb4f2ab537566377232e5c",
    "ID": "746C51BA1435825AB14A57BAEE89DFAFAD4834",
    "FileName": "002 Application PIM and_or BC.PDF",
    "PublicUrl": "https://hccpublicportaldocuat.azurewebsites.net/api/download/381b294ce8bb4f2ab537566377232e5c/_property/746C51BA1435825AB14A57BAEE89DFAFAD4834",
    "Columns": [{
        "Name": "LastModified",
        "Value": "9/1/2017 11:20:14 PM"
    }, {
        "Name": "ApplicationNo",
        "Value": "ABA970034"
    }]
}]

*/

import $ from 'jquery';
import _, { toPath } from 'lodash';

(function(){
    'use strict';

    squiz.fn.searchTableResult = function() {



        function filterResults() {
            
            // Everytime we are filtering, we deal with the original result set
            results_processed = _.cloneDeep(results_original);

            // Filter results by select inputs
            // Check if object has keys (set from select field change event) because its possible some searches may not have select filters
            if (!_.isEmpty(select_filters)) {

                results_processed = results_processed.filter(function(result) {

                    for (var col_name in select_filters) {

                        if (select_filters.hasOwnProperty(col_name)) {
                            
                            var matching_result_column_object = _.find(result.Columns, function(obj) { 
    
                                // If api_name in loop is ApplicationNo, then the following is returned
                                /*
                                    {
                                        "Name": "LastModified",
                                        "Value": "9/1/2017 11:20:14 PM"
                                    }
                                */
                                return obj.Name === col_name;
    
                            });

                            if (matching_result_column_object) {

                                if (matching_result_column_object.Value !== select_filters[col_name]) {

                                    return false;

                                }
                                
                            } else {

                                // This column doesn't event exist in the result columns
                                return false;

                            }

                        }

                    }

                    return true;
                    
                });

            }

            // Filter results by string input 
            if (input_filter.length) {

                results_processed = results_processed.filter(function(result) {

                    // First, check if this result set has a "FileName" property (Document results)
                    if (result.hasOwnProperty("FileName") && squiz.fn.isSubString(result.FileName, input_filter)) {
    
                        return true;
    
                    } else {
    
                        var config_details_columns = results_config.detailsColumns;
    
                        // Loop through each user defined API name in the config detailsColumns property
                        // e.g. Loop through ["Description", "Year", "ApplicationNo", "LastModified"]
                        for (var i = 0; i < config_details_columns.length; i++) {
    
                            // For each user defined API name, get the relevant object from the result columns array
                            /*
                                "Columns": [{
                                    "Name": "LastModified",
                                    "Value": "9/1/2017 11:20:14 PM"
                                }, {
                                    "Name": "ApplicationNo",
                                    "Value": "ABA970034"
                                }]
                            */
                            var matching_result_column_object = _.find(result.Columns, function(obj) { 
    
                                // If api_name in loop is ApplicationNo, then the following is returned
                                /*
                                    {
                                        "Name": "LastModified",
                                        "Value": "9/1/2017 11:20:14 PM"
                                    }
                                */
                                return obj.Name === config_details_columns[i];
    
                            });
    
                            if (matching_result_column_object && squiz.fn.isSubString(matching_result_column_object.Value, input_filter)) {
                            
                                // Only break the for loop if the string filter is found within the value of the result column object value
                                return true;
                                
                            }
    
                        }
                        
                    }
    
                });

            }
            
            // After filtering the original unsorted results, store a copy of the new filtered results as unsorted filtered results
            results_processed_unsorted = _.cloneDeep(results_processed);

            processedResultsUpdated();

        }

        function setupSelectFilters() {

            var $select_filters = $search_results_table.find(".smp-search-table-results__select-filter");

            if ($select_filters.length) {

                // Build the filter col data structure for reference later when filtering results
                select_filters = {};


                $select_filters.each(function() {
                    
                    var $this_select_filter = $(this);

                    var $this_select_filter_col_name = $this_select_filter.data("filter-col");

                    // Setup change event
                    $this_select_filter.on("change", function() {

                        var selected_filter_value =  $this_select_filter.val();

                        if (selected_filter_value.length) {
                            
                            // Add/update key/pair value
                            select_filters[$this_select_filter_col_name] = selected_filter_value

                        } else {

                            // Remove key/pair value
                            delete select_filters[$this_select_filter_col_name];

                        }

                        filterResults();

                    });

                    $this_select_filter.prop("disabled",false);

                    $this_select_filter.select2({
                        width: "style", // Get rid of style attribute
                        dropdownParent: $("main"), // Has to be in main because of font styles targeting only within main
                    }).on("select2:open", function(e) {
                        $(".select2-search--dropdown .select2-search__field").attr("placeholder", "Search...");
                    }).on("select2:close", function() {
                        $(".select2-search--dropdown .select2-search__field").attr("placeholder", null);
                    });

                });

            }

        }

        function setupInputFilter() {

            var $input_filter = $search_results_table.find(".smp-search-table-results__filter");

            if ($input_filter.length) {

                input_filter = "";

                $input_filter.on("input", squiz.fn.debounce(function() {

                    input_filter = $input_filter.val();

                    filterResults();
                                    
                }, 500));

                $input_filter.prop("disabled",false);

            }

        };

        function sortFilteredResults() {
            
            if (current_sort) {

                results_processed.sort(function (result_a, result_b) {
                
                    var value_A = "";
                    var value_B = "";
    
                    if (current_sort == "FileName") {
                        
                        value_A = result_a.FileName;
                        value_B = result_b.FileName;
                        
                    } else {
    
                        // Need to look at each column in array to find matching object where its name is equal to current_sort value in dropdown
                        var matching_result_column_object_a = _.find(result_a.Columns, function(obj) { 
    
                            return obj.Name === current_sort;
    
                        });
    
                        if (matching_result_column_object_a && matching_result_column_object_a.Value) {
    
                            value_A = matching_result_column_object_a.Value;
    
                        }
    
                        var matching_result_column_object_b = _.find(result_b.Columns, function(obj) { 
    
                            return obj.Name === current_sort;
    
                        });
    
                        if (matching_result_column_object_b && matching_result_column_object_b.Value) {
    
                            value_B = matching_result_column_object_b.Value;
    
                        }

                        if (current_sort == "LastModified") {
    
                            // Convert to UNIX Time stamps
                            value_A =  (new Date(value_A).getTime() / 1000);
                            value_B =  (new Date(value_B).getTime() / 1000);
        
                        }
    
                    }

                    if (typeof value_A != "string") {
                        value_A = value_A.toString();
                    }

                    if (typeof value_B != "string") {
                        value_B = value_B.toString();
                    }
    
                    var compare_result = value_A.localeCompare(value_B, undefined, {numeric: true, sensitivity: 'base'});

                    if (compare_result > 0) {

                        return 1;

                    } else if (compare_result < 0) {

                        return -1;

                    } else {

                        return 0

                    }

                    
                });

            } else {

                // Set back to original unsorted processed results
                results_processed = _.cloneDeep(results_processed_unsorted);
                
            }
            
        }

        function setupSort() {

            var $sort = $search_results_table.find(".smp-search-table-results__sort");

            if ($sort.length) {

                // Setup on change event listener
                $sort.on("change", function() {

                    current_sort = $(this).val();

                    processedResultsUpdated();
                    
                });

                $sort.prop("disabled", false);

            }

        }

        function processedResultsUpdated() {

            sortFilteredResults();
                    
            // After sorting, we should go back to page 1
            resetPagination();

            // Render the new search results table
            render();

        }

        function renderPagination() {

            var pagination_html = "";

            if (total_pages > 1)  {

                pagination_html += '<div aria-label="Results pagination" class="smp-pagination"><ul class="pagination">';

                // Previous page icon link
                if (current_page != 1) {

                    pagination_html = pagination_html + '<li class="page-item"><button class="page-link" aria-label="Previous page" data-page=' + (current_page - 1) + '><span class="fas fa-arrow-left"></span></button></li>';
                    
                }

                for (var page_num = first_page; page_num < (first_page + pagination_links); page_num++) {

                    if (page_num == current_page) {

                        pagination_html = pagination_html + '<li class="page-item active" aria-current="page"><button class="page-link" data-page="' + page_num + '">' + page_num + '</button></li>';

                    } else {

                        pagination_html = pagination_html + '<li class="page-item"><button class="page-link" data-page="' + page_num + '" aria-label="Go to Page ' + page_num + '">' + page_num + '</button></li>';

                    }

                }

                // Next page icon link
                if (current_page != total_pages) {

                    pagination_html = pagination_html + '<li class="page-item"><button class="page-link" aria-label="Next page" data-page="' + (current_page + 1) + '"><span class="fas fa-arrow-right"></span></button></li>';

                }

                pagination_html += '</ul></div>';

            }

            return pagination_html;

        }

        function renderTableResults() {

            // Get the current page subset
            var current_page_results = results_processed.slice( ((current_page - 1) * num_results_per_page), (current_page * num_results_per_page) );

            var table_results_data = {
                "config": results_config,
                "results": current_page_results
            }

            var table_results_html = search_results_table_compiled_template(table_results_data)

            return table_results_html;

        }

        function render() {

            var html = "";

            html += renderTableResults();
            html += renderPagination();
            
            // Using innerHTML rather than .empty().append() because native innerHTML is faster
            $search_results_table_wrapper[0].innerHTML = html;

            // Need to re-setup responsive table if it exists
            var $new_results_table = $search_results_table.find("table");
            
            var responsiveTableInstance = squiz.fn.responsiveTable();

            responsiveTableInstance.init($new_results_table);
            
        }

        function calculatePagination() {

            total_results_processed = results_processed.length;
            total_pages = Math.ceil(total_results_processed / num_results_per_page);

            // Page links
            if (total_pages < pagination_limit) {
        
                pagination_links = total_pages

            } else {

                // Do this only if there are more total pages than the set pagination limit
                if (current_page > (total_pages - Math.floor(pagination_limit / 2))) {

                    first_page = total_pages - (pagination_limit - 1)
                    
                } else if (current_page > Math.floor(pagination_limit / 2) ) {

                    first_page = current_page - Math.floor(pagination_limit / 2)

                }
                
            }

        }

        function resetPagination() {

            current_page = 1;
            first_page = 1;
            pagination_links = pagination_limit;

            calculatePagination();

        }

        function setupPaginationLinkClick() {

            $search_results_table.on("click", ".page-link", function(event) {

                // Each pagination link should contain a data attribtue called page which holds a page number
                // Once clicked on, thats the new current page
                current_page = $(event.currentTarget).data("page");

                // Re-render results and pagination
                calculatePagination();

                render();

                // Scroll to top of results table
                $("html,body").animate({
                    scrollTop: $search_results_table_wrapper.offset().top - 150
                }, 500);
                

            });

        }

        function resetResults() {

            // Everytime the render() function is called, its relying on whatever is stored in this variable results_processed to render the results search table
            results_processed = _.cloneDeep(results_original);

            // We also need to store a copy of what the current unsorted result set is so that if user selects "No sort", we can revert to what the unsorted order was
            // This var is updated everytime filtering happens or filtering input field becomes blank
            results_processed_unsorted = _.cloneDeep(results_original);

        }

        function init($search_results_table_arg) {

            $search_results_table = $search_results_table_arg;
            $search_results_table_wrapper = $search_results_table.find(".smp-search-table-results__wrapper");
            
            var $search_results_table_template = $search_results_table.find(".smp-search-table-results__template");
            
            results_config = $search_results_table_template.data("config");
            results_original = $search_results_table_template.data("results");
            
            if ($search_results_table_wrapper.length && $search_results_table_template.length && results_original && results_config) {

                // Compile handlebars
                search_results_table_compiled_template = Handlebars.compile($search_results_table_template.html());

                resetResults();

                // Reset pagination related variables (Start on page 1)
                resetPagination();

                // Setup the pagination link clicks
                setupPaginationLinkClick();

                // Render the search results table
                render();

                // Setup filter feature
                setupInputFilter();

                // Setup select filters feature
                setupSelectFilters();

                // Setup sorting feature
                setupSort();

            }

        }

        var $search_results_table;
        var search_results_table_compiled_template;
        var $search_results_table_wrapper;


        var input_filter; // Store the current input filter value as a string
        var select_filters; // Store the current select filters options as a JS object
        var current_sort; // Store current sorting option as a string

        var results_config;
        var results_original;

        // This stores the current filtered and/or sorted results set
        // Whatever is stored here is used to render the search results table
        var results_processed;

        // This stores the unsorted filtered result set to refer to in case user selects no sort option
        var results_processed_unsorted;

        

        // Pagination related
        var num_results_per_page = 10;
        var pagination_limit = 5; // Define how many page links to ideally display at a time in the pagination component
        var pagination_links; // Determines how many real links to render
        var total_results_processed; // Count of how many total filtered results
        var total_pages; // Keep track of total number of pages of results
        var current_page; // Keep track of what page number user is on

        // Everytime the pagination is rendered, this represents the page number of the first pagination link based on what current page the user is on
        // e.g. If I'm on page 7, this should be 2
        var first_page;

        return {
            init: init
        }

     };

     document.addEventListener("DOMContentLoaded", function () {

        var $search_results_tables = $(".smp-search-table-results");

        if ($search_results_tables.length) {

            $search_results_tables.each(function() {
                
                var $this_search_results_table = $(this);

                // Instantiate the object instance
                var searchTableResultInstance = squiz.fn.searchTableResult();

                searchTableResultInstance.init($this_search_results_table);

            });

        }
        
    });

}());
